import "./App.css";
import { Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import "./i18n";
import { useTranslation } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";


function App() {
  return (
    <div className="App">
      <header className="mb-[5vh] md:mb-[4vh] lg:mb-[2vh]">
        <Nav></Nav>
      </header>
      <main className="App-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
    </div>
  );
}

function Home() {
  const { t } = useTranslation();
  return (
    <>
      <HelmetProvider>
        <script type="text/javascript" src="portal.js"></script>
      </HelmetProvider>
      <main>
        <h2 className="italic">{t("basic_title")}</h2>
        <p>{t("basic")}</p>
      </main>
    </>
  );
}

function About() {
  const { t } = useTranslation();
  return (
    <>  
      <main>
        <p className="m-2 px-4 md:m-6 md:px-8 text-left">
          {t("about")}
          <a
            className="font-extrabold hover:underline rounder-md"
            href="https://hypha.coop"
          >
            HYPHA
          </a>
        </p>
      </main>
    </>
  );
}

function Projects() {
  const { t } = useTranslation();
  return (
    <>
      <main>
        <p className="m-1 my-2 px-4 md:m-6 md:px-8 text-left">
          {t("projects_A")}
          </p>
          <p className="m-1 my-2 px-4 md:m-6 md:px-8 text-left">
          {t("projects_B")}
          <a
            className="italic font-extrabold hover:underline"
            href="https://ffforests.xyz"
          >
            fabricating future forests
          </a>
          {t("projects_ext")}
          </p>
          <p className="m-1 my-2 px-4 md:m-6 md:px-8 text-left">

          {t("projects_ext1")}

          <a
            className="italic font-extrabold hover:underline"
            href="https://vincentcharlebois.net//nodes.html"
          >
            nodes
          </a>
          {t("projects_ext2")}
        </p>
        <p className="m-1 my-2 px-4 md:m-6 md:px-8 text-left">
          {t("projects_now")}
        </p>
      </main>
    </>
  );
}

function Contact() {
  const { t } = useTranslation();
  return (
    <>
      <main>
      <p className="px-5 pt-7 pb-7 mb-[10vh] text-2xl">
          {t("studio")}
          <br></br>
          <a
            className="text-2xl hover:underline font-black italic inline-block"
            href="https://twitter.com/vncntxyz"
          >
            𝑿𝑿 𝑪 — Couleur de Montréal (@vncntxyz)
          </a>
        </p>
        <p className="text-2xl text-left px-5 pt-7 pb-7 mb-1 w-80">
          {t("contact")}
          </p>
        <div className="px-5 text-center">
          <ul>
          <li className="py-2">
              <a
                className="hover:underline font-medium contact-links"
                href="https://tripledoublev.github.io/CV/"
              >
                 CV 
              </a>
            </li>
          <li className="py-2">
              <a
                className="hover:underline font-medium contact-links"
                href="mailto:vincent@charlebois.info"
              >
                 email 
              </a>
            </li>
            <li className="py-2">
              <a
                className="hover:underline font-medium contact-links"
                href="https://github.com/tripledoublev"
              >
                 github 
              </a>
            </li>
            <li className="py-2">
              <a
                className="hover:underline font-medium contact-links"
                href="https://twitter.com/vincencharleboi"
              >
                 twitter 
              </a>
            </li>
            <li className="py-2">
              <a
                className="hover:underline font-medium contact-links"
                href="https://instagram.com/ffforests"
              >
                 instagram 
              </a>
            </li>
            
            <li className="py-2">
              <a
                className="hover:underline font-medium contact-links"
                href="https://www.vincentcharlebois.net/"
              >
                 portfolio 
              </a>
            </li>
            
          </ul>
        </div>
        
      </main>
    </>
  );
}

export default App;
